<template>
  <div class="eq-search-panel">
    <div class="eq-search-panel__form">
      <slot />
    </div>
    <div v-if="$slots.actions" class="eq-search-panel__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchPanel'
}
</script>

<style lang="scss" scoped>
.eq-search-panel {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  margin-bottom: 16px;
}

.eq-search-panel__form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  flex: 1;
  min-width: 0;

  ::v-deep .el-input,
  ::v-deep .el-select,
  ::v-deep .el-date-editor { width: 180px; }
  ::v-deep .el-input__inner { height: 32px; line-height: 32px; }
}

.eq-search-panel__actions { display: flex; gap: 8px; flex-shrink: 0; }

@media screen and (max-width: 1200px) {
  .eq-search-panel__form {
    ::v-deep .el-input,
    ::v-deep .el-select,
    ::v-deep .el-date-editor { width: 160px; }
  }
}

@media screen and (max-width: 768px) {
  .eq-search-panel { flex-direction: column; }
  .eq-search-panel__form {
    width: 100%;
    ::v-deep .el-input,
    ::v-deep .el-select,
    ::v-deep .el-date-editor { width: 100%; }
  }
}
</style>
